define('entrypoint',[
    'prototypes/console',
    'prototypes/fonts-autoload',
    'jqueryShim',
    'prototypes/modernizrTests',
    'template',
    'prototypes/templateFactory',
    'prototypes/GoogleMaps',
    'prototypes/ReCaptcha',
    'models/SetupModel',
    'views/AppView',
    'LogExecutionTime',
    'UrlFactory',
    'requestAnimationFrame',
    'moment'
],
    function(console,
        fontsAutoload,
        jqueryShim,
        modernizrTests,
        template,
        templateFactory,
        GoogleMaps,
        ReCaptcha,
        SetupModel,
        AppView,
        LogExecutionTime,
        UrlFactory,
        requestAnimationFrame,
        moment,
        momentRound
    ){

    LogExecutionTime('starting AppView ...');
    new AppView();
    LogExecutionTime('... AppView started');

    function EntryPoint(){
        if(fontsAutoload(EntryPoint)){
            LogExecutionTime('starting SetupModel...');
            new SetupModel();
            LogExecutionTime('... SetupModel started');
        }else{
            LogExecutionTime('... waiting CSS');
        }
    }

    // Entry Point
    return EntryPoint;

});
